var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D4\\u05E4\\u05D5\\u05E4\\u05D0\\u05E4-\\u05D4\\u05DE\\u05E9\\u05D5\\u05D3\\u05E8\\u05D2",
    transform: "translate(-672.000000, -100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(672.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-24px",
    fill: "#0091FF",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C13.9705627,-9.13077564e-16 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 6.08718376e-16,13.9705627 0,9 C-6.08718376e-16,4.02943725 4.02943725,9.13077564e-16 9,0 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "edit-24px",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 14 0 14 14 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625,8.95146507 L2.625,10.2812804 C2.625,10.4037634 2.72123663,10.5 2.84371962,10.5 L4.17353493,10.5 C4.23040203,10.5 4.28726913,10.478128 4.32663866,10.4343841 L9.10347521,5.66192196 L7.46307804,4.02152479 L2.69061589,8.79398695 C2.64687196,8.83773087 2.625,8.89022358 2.625,8.95146507 Z M10.372049,4.39334815 C10.5426503,4.22274684 10.5426503,3.94716012 10.372049,3.77655881 L9.34844119,2.75295098 C9.17783988,2.58234967 8.90225316,2.58234967 8.73165185,2.75295098 L7.93113804,3.5534648 L9.5715352,5.19386196 L10.372049,4.39334815 Z",
    id: "Shape",
    fill: "#0091FF",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c2e1ed5508f3afc31ea71f18fcb666dc.svg";
export { ForwardRef as ReactComponent };